import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@mantine/core';
import styles from './UltraProductSummary.module.scss';
import ValuePropsBox from '../../../views/ProductDetails/Series3CollarDetails/components/ValuePropsBox';
import { Image as FiImage } from '../../Image';
import { ReactComponent as IconDrip } from '../../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconCellular } from '../../../assets/images/icons/icon_cellular.svg';
import { ReactComponent as IconBatteryCharging } from '../../../assets/images/icons/icon_battery_charging.svg';
import { ReactComponent as IconVibration } from '../../../assets/images/icons/icon_vibration.svg';
import { ReactComponent as IconConnected } from '../../../assets/images/icons/icon_connected.svg';

const SpecItem = ({ title, description }: { title: string; description: string }) => (
  <Stack spacing={10} pb={30}>
    <Text fz={20} fw={700} lh="120%" sx={{ letterSpacing: '-0.4px', whiteSpace: 'pre-line' }}>
      {title}
    </Text>
    <Text fz={16} fw={500} lh="140%" sx={{ whiteSpace: 'pre-line' }}>
      {description}
    </Text>
  </Stack>
);

export default function UltraProductSummary() {
  const { t } = useTranslation();

  return (
    <div className={styles.specsSection}>
      <div className={styles.hardwareImage}>
        <FiImage
          image={{
            type: 'image',
            url: '/product_images/ultra/unboxing.png',
          }}
        />
      </div>
      <h2 className={styles.specsHeading}>{t('ultra_specs')}</h2>
      <div className={styles.specsGrid}>
        <ValuePropsBox
          className={styles.valuePropsBox}
          columns={1}
          direction="column"
          valueProps={[
            {
              icon: <IconVibration />,
              text: (
                <SpecItem
                  title={t('ultra_positive_reinforcement')}
                  description={t('ultra_positive_reinforcement_desc')}
                />
              ),
            },
            {
              icon: <IconCellular />,
              text: <SpecItem title={t('ultra_best_coverage')} description={t('ultra_best_coverage_desc')} />,
            },
            {
              icon: <IconDrip />,
              text: <SpecItem title={t('ultra_waterproof')} description={t('ultra_waterproof_desc')} />,
            },
            {
              icon: <IconBatteryCharging />,
              text: <SpecItem title={t('ultra_battery_life')} description={t('ultra_battery_life_desc')} />,
            },
            {
              icon: <IconConnected />,
              text: (
                <SpecItem title={t('ultra_works_solo_or_paired')} description={t('ultra_works_solo_or_paired_desc')} />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}
